<template>
  <b-form>
    <b-form-group
      description="Send Now"
      label="Send now?"
      :label-cols="3"
      :horizontal="true">
      <b-form-checkbox :checked="sendNow" v-model="sendNow"/>
    </b-form-group>
    <b-form-group
      v-if="!sendNow"
      description="Send At Date"
      label="Send At"
      :label-cols="3"
      :horizontal="true"
    >
      <datepicker input-class="form-control" v-model="sendAt"/>
    </b-form-group>
    <b-form-group
      v-if="!sendNow"
      description="Send At Time"
      label="Send Time"
      :label-cols="3"
      :horizontal="true"
    >
      <vue-timepicker v-model="sendTime"></vue-timepicker>
    </b-form-group>
    <div slot="footer">
      <b-button v-on:click="onSendClick">
        Save
      </b-button>
    </div>
  </b-form>
</template>

<script>
import Datepicker from "vuejs-datepicker/src/components/Datepicker";
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  name: "ScheduleCampaign",
  components: {
    Datepicker,
    VueTimepicker,
  },
  data() {
    return {
      sendNow: true,
      sendAt: null,
      sendTime: null,
    }
  },
  methods: {
    onSendClick() {
      let date = this.sendNow ?
        this.$moment(this.$moment.now()).add(2, 'minutes').format('LLLL') :
        this.
          $moment(this.sendAt)
          .format('YYYY-MM-DD') + 'T' + this.sendTime.HH + ':' + this.sendTime.mm
      ;
      this.$emit('click', date);
    }
  },
}
</script>
